import { PopperProps } from '@mui/material'
import TooltipIcon from 'ext-ui/components/TooltipIcon/TooltipIcon'
import React from 'react'
import SvgAutoReview from 'src/components/Svgs/SvgAutoReview'
import SvgCheckNew from 'src/components/Svgs/SvgCheckNew'
import SvgClock from 'src/components/Svgs/SvgClock'
import SvgFlagNew from 'src/components/Svgs/SvgFlagNew'
import { useTranslate } from 'src/localization/Trns'
import {
  TransactionManagerRejectionReason,
  transactionManagerReviewRejectionReasonToString,
  TransactionManagerReviewStatus,
} from 'src/models/transaction.models'

interface ManagerReviewIconTooltipCellProps {
  status: TransactionManagerReviewStatus | undefined
  rejectionReason?: TransactionManagerRejectionReason
  placement?: PopperProps['placement']
}

const ManagerReviewIconTooltipCell: React.FC<
  ManagerReviewIconTooltipCellProps
> = ({ status, rejectionReason, placement = 'top' }): React.ReactElement => {
  const translate = useTranslate()

  let icon: React.ReactElement
  let iconTestId: string
  let message: string

  switch (status) {
    case TransactionManagerReviewStatus.Reviewed:
      icon = <SvgCheckNew />
      iconTestId = 'reviewedReviewIcon'
      message = translate('Manager Reviewed')
      break
    case TransactionManagerReviewStatus.Rejected: {
      icon = <SvgFlagNew />
      iconTestId = 'flagReviewIcon'
      const reason = translate(
        transactionManagerReviewRejectionReasonToString(rejectionReason),
      )
      message = translate('Manager Rejected: ${reason}', { reason })
      break
    }
    case TransactionManagerReviewStatus.AutoReviewed:
      icon = <SvgAutoReview />
      iconTestId = 'autoReviewIcon'
      message = translate('Auto-reviewed transaction')
      break
    case TransactionManagerReviewStatus.PendingReview:
    default:
      icon = <SvgClock />
      iconTestId = 'pendingReviewIcon'
      message = translate('Pending Manager Review')
      break
  }

  return (
    <TooltipIcon
      placement={placement}
      icon={icon}
      iconTestId={iconTestId}
      disableInteractive={true}
      enterDelay={0}
      exitDelay={0}
    >
      {message}
    </TooltipIcon>
  )
}

export default ManagerReviewIconTooltipCell
